import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import BackgroundShapes from './BackgroundShapes';

const PageHero = ({ title, subtitle, emoji, badge }) => {
    return (
        <Box sx={{
            background: 'linear-gradient(135deg, #43a047, #66bb6a)',
            color: 'white',
            py: 8,
            position: 'relative',
            overflow: 'hidden'
        }}>
            <BackgroundShapes variant="dots" opacity={0.1} />
            <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
                <Box sx={{ textAlign: 'center' }}>
                    <Box sx={{ fontSize: '5rem', mb: 2 }}>{emoji}</Box>
                    <Typography variant="h2" fontWeight={800} gutterBottom>
                        {title}
                    </Typography>
                    <Typography variant="h5" sx={{ opacity: 0.9, mb: 3 }}>
                        {subtitle}
                    </Typography>
                    {badge && (
                        <Paper sx={{
                            display: 'inline-block',
                            px: 3,
                            py: 1,
                            background: 'rgba(255,255,255,0.2)',
                            color: 'white',
                            fontWeight: 600
                        }}>
                            {badge}
                        </Paper>
                    )}
                </Box>
            </Container>
        </Box>
    );
};

export default PageHero;
